import { createStore } from 'solid-js/store'
import { createSignal } from 'solid-js'
import { defaultReservedCloseTime } from '@lib/constants'

export const [store, setStore] = createStore({
  gameAccount: {},
  reservedCloseTime: defaultReservedCloseTime,

  newlyPlayerNumbers: 0,
})
